/* eslint-disable no-new */


import EDC from '@/components/games/shared/globals';
import { MenuPreloader } from '@/components/games/shared/menu';
// import BackgroundPreloader from '../../../../components/games/shared/preloader-background';
/**
 *
 */
EDC.Games.TitleMenu.Scenes.Preloader = function () {};
/**
 *
 */
EDC.Games.TitleMenu.Scenes.Preloader.prototype.create = function () {
  this.load.setPath('https://s3.amazonaws.com/images.growmindgrow/phaser-assets/images/backgrounds/');

  this.load.on('complete', this.onLoadImagesComplete, this);

  this.load.image('background', 'menu_bg.jpg');
  // new BackgroundPreloader(this, cfg.bgList);
  new MenuPreloader(this);

  this.load.start();
};
/**
 *
 */
EDC.Games.TitleMenu.Scenes.Preloader.prototype.onLoadImagesComplete = function () {
  this.load.off(this.onLoadImagesComplete, this);
  this.scene.start('TitleMenu-Main');
};

export default EDC.Games.TitleMenu.Scenes.Preloader;
